import { ASNFormData } from './types';

interface ShipmentDetailsStepProps {
  formData: ASNFormData;
  onChange: (field: keyof ASNFormData, value: string) => void;
}

export function ShipmentDetailsStep({ formData, onChange }: ShipmentDetailsStepProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">
            Courier <span className="text-red-500">*</span>
          </label>
          <select
            value={formData.courier}
            onChange={(e) => onChange('courier', e.target.value)}
            required
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="fedex">FedEx</option>
            <option value="ups">UPS</option>
            <option value="dhl">DHL</option>
            <option value="tnt">TNT</option>
            <option value="dpd">DPD</option>
            <option value="own_transport">Own Transport</option>
            <option value="poeton_transport">Poeton Transport</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">
            Tracking Number <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={formData.tracking_number}
            onChange={(e) => onChange('tracking_number', e.target.value)}
            required
            placeholder="1234567890"
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
      </div>

      {formData.courier === 'other' && (
        <div>
          <label className="block text-sm font-medium mb-2">
            Courier Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={formData.courier_other}
            onChange={(e) => onChange('courier_other', e.target.value)}
            required
            placeholder="Enter courier name"
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <p className="text-xs text-muted-foreground mt-1">
            Tracking details for custom couriers may not be available.
          </p>
        </div>
      )}

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">
            Transport Method <span className="text-red-500">*</span>
          </label>
          <select
            value={formData.method_of_transport}
            onChange={(e) => onChange('method_of_transport', e.target.value)}
            required
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="road">Road</option>
            <option value="rail">Rail</option>
            <option value="air">Air</option>
            <option value="sea">Sea</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">
            Expected Delivery Date <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            value={formData.expected_delivery_date}
            onChange={(e) => onChange('expected_delivery_date', e.target.value)}
            required
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">
            Weight (kg) <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            step="0.01"
            value={formData.weight_kg}
            onChange={(e) => onChange('weight_kg', e.target.value)}
            required
            placeholder="100.00"
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Distance (km)</label>
          <div className="w-full px-3 py-2 border rounded-lg bg-muted/40 text-sm text-muted-foreground">
            Auto-calculated on save (customer ↔ delivery site)
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Notes (Optional)</label>
        <textarea
          value={formData.notes}
          onChange={(e) => onChange('notes', e.target.value)}
          rows={3}
          placeholder="Add any additional shipping information..."
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
        />
      </div>
    </div>
  );
}
